import styled from 'styled-components';

export const DescriptionText = styled.div`
    p {
        margin-bottom: 0;
    }

    ol {
        padding-left: 0;
        list-style: inside decimal;
    }

    ul {
        list-style: none;
        padding: 0;
    }

    li {
        text-indent: -1.5em;
        padding-left: 1.5em;
    }

    ul > li:before {
        content: '•';
        color: #06befb;
        font-size: 30px;
        vertical-align: sub;
        padding-right: 8px;
    }
`;
